<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <CommonPanel>
          <v-row align="baseline">
            <v-col>
              <v-row  align="center">
                <v-avatar color="secondary" size="70" class="ma-5">
                <span class="white--text text-h5">{{
                  accountInfo.profile.name[0]
                }}</span>
              </v-avatar>
              <p class="text-h5 fontGrey--text">
                {{ accountInfo.profile.name }}
              </p>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                :label="'כינוי'"
                v-model="userNicName"
                outlined
                :rules="nameRules"
              />
            </v-col>         
          </v-row>
          <v-row justify="center">     
            <v-col cols="12" md="6">
              <!-- :value="userName"  -->
              <v-text-field :label="userDetails[0]" :rules="nameRules" outlined v-model="userName">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <!-- :value="userAddress" -->
              <v-text-field
                :label="userDetails[1]"
                outlined
                v-model="userAddress"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <!-- :value="userEmail" -->
              <v-text-field :label="userDetails[2]" :rules="emailRules" outlined v-model="userEmail">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <!-- :value="userMainPhone" -->
              <v-text-field
                :label="userDetails[3]"
                outlined
                v-model="clientPhone"
                counter="10"     
                background-color="white"
                filled     
                autofocus
                placeholder="הכנס מס טלפון"
                :hint="placeholder"
                v-mask="'##########'"
                :rules="phoneRules"
                required
              >
              </v-text-field>
            </v-col>          
          </v-row>
          <v-row justify="center">
            <!-- update -->
            <v-col cols="12" md="4">
              <v-btn color="success" block text plain outlined class="mr-4 text-h5" @click="updateAccount">
                {{ $t("$vuetify.commonTexts.buttons.save") }}
              </v-btn>
            </v-col>
           
          </v-row>
        </CommonPanel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiCalls from "@/mixins/apiCalls.js";
import { mapState, mapActions } from "vuex";
import inputRules from "@/mixins/inputRules";

export default {
  name: "AccountProfile",
  mixins: [apiCalls, inputRules],
  components: {
    CommonPanel: () => import("@/components/CommonComponents/CommonPanel"),
  },
  data() {
    return {
      userDetails: ["שם מלא", "כתובת", "אימייל", "מספר טלפון ראשי"],
      userNicName: null,
      clientName: null,
      clientAddress: null,
      clientEmail: null,
      clientPhone: null,
      selectedIdType: null,
      placeholder: "0553302411",
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account.account,
      accountInfo: (state) => state.account.accountInfo,
    }),
    userName:  {
      get() {
        return this.accountInfo.profile.name;
      },
      set(val) {
        this.clientName = val
      }
    },
    userAddress: {
      get() {
        return this.accountInfo.profile.address;
      },
      set(val) {
        this.clientAddress = val
      }    
    },
    userEmail: {
      get() {
        return this.accountInfo.profile.email;
      },
      set(val) {
        this.clientEmail = val
      }      
    },
  },
  mounted() {
    this.clientPhone = this.accountInfo.profile.contact_phone;      
  },
  methods: {
    ...mapActions([
      "setAccountInfo",
    ]),
    async updateAccount() {
      const appAction = false;
      const functionName = "prov_update_account_profile";
      // lang: "EN"
      const reqBody = {
        address: this.clientAddress,
        contact_phone: this.clientPhone,
        email: this.clientEmail,
        account_id: this.account.domain_id,
        name: this.clientName, // ???
        contact_name: this.clientName,       
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.getAccountInfo()
      } 
      // else {
       
      // }
    },
    async getAccountInfo() {
      const appAction = false;
      const functionName = "get_account_info";
      const reqBody = {
        account_id: this.account.domain_id,
      };
      try{
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      // console.log('data in accountInfo : ', data);
      if (data.error_code === 200) {
        await this.$store.dispatch("setAccountInfo", data.data);
        this.$emit('closeEditMode')
      }
    } catch (e) {
        console.error(e);
      }
    },

  }
};
</script>
